"use strict";

exports.__esModule = true;
exports.ElementEditorBaseLayer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _ElementRenderer = require("../../ElementRenderer");
var _Theme = require("../../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BaseLayerContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorBaseLayer__BaseLayerContainer",
  componentId: "sc-15rih73-0"
})(["position:relative;background:", ";box-shadow:0 0 20px rgba(0,0,0,0.4) inset;display:flex;overflow:auto;padding:20px;padding-bottom:70px;"], (0, _Theme.val)("WorkspaceBackground"));
var RootElementContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorBaseLayer__RootElementContainer",
  componentId: "sc-15rih73-1"
})(["position:relative;top:0;left:0;right:0;bottom:0;margin:auto;background:rgba(255,255,255,0.5);box-shadow:0 4px 20px rgba(0,0,0,0.4);.", " &{background:rgba(0,0,0,0.5);}"], _core.Classes.DARK);

/**
 * Renders the root element on a base layer.
 */
var ElementEditorBaseLayer = exports.ElementEditorBaseLayer = /*#__PURE__*/function (_Component) {
  function ElementEditorBaseLayer() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.modifyProps = function (props) {
      return Object.assign({}, props, {
        widgets: _this.props.elementEditor.widgets || []
      });
    };
    return _this;
  }
  _inheritsLoose(ElementEditorBaseLayer, _Component);
  var _proto = ElementEditorBaseLayer.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      width = _this$props.width,
      height = _this$props.height;
    var components = elementEditor.components,
      widgets = elementEditor.widgets,
      rootElement = elementEditor.rootElement;
    var rootWidth = rootElement.props.width || width;
    var rootHeight = rootElement.props.height || height;
    var style = {
      width: rootWidth,
      height: rootHeight
    };
    return /*#__PURE__*/_react["default"].createElement(BaseLayerContainer, {
      style: {
        width: width,
        height: height
      },
      "data-testid": "ElementEditorBaseLayer"
    }, /*#__PURE__*/_react["default"].createElement(RootElementContainer, {
      style: style
    }, /*#__PURE__*/_react["default"].createElement(_ElementRenderer.ElementRenderer, {
      widgets: widgets,
      components: components,
      config: rootElement,
      modifyProps: this.modifyProps
    })));
  };
  return ElementEditorBaseLayer;
}(_react.Component);